import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const PaymentTermsSection = ({ formData, handleInputChange, errors }) => {
  const paymentCycleOptions = [
    { value: 'daily', label: 'Harian' },
    { value: 'weekly', label: 'Mingguan' },
    { value: 'biweekly', label: 'Dua Mingguan' },
    { value: 'monthly', label: 'Bulanan' },
    { value: 'custom', label: 'Kustom' }
  ];

  const customerPaymentOptions = [
    { value: 'cash', label: 'Tunai' },
    { value: '7days', label: '7 Hari' },
    { value: '14days', label: '14 Hari' },
    { value: '30days', label: '30 Hari' },
    { value: '45days', label: '45 Hari' },
    { value: '60days', label: '60 Hari' }
  ];

  return (
    <div className="card">
      <div className="flex items-start gap-4 mb-6">
        <div className="w-12 h-12 rounded-xl bg-accent/10 flex items-center justify-center flex-shrink-0">
          <Icon name="Calendar" size={24} color="var(--color-accent)" />
        </div>
        <div className="flex-1">
          <h2 className="text-2xl md:text-3xl font-semibold mb-2">Syarat Pembayaran</h2>
          <p className="text-sm md:text-base text-muted-foreground">
            Kelola siklus pembayaran dengan pemasok dan pelanggan untuk analisis arus kas
          </p>
        </div>
      </div>
      <div className="space-y-6 md:space-y-8">
        <div className="p-4 md:p-6 bg-muted rounded-lg">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-lg bg-card flex items-center justify-center">
              <Icon name="Users" size={20} color="var(--color-primary)" />
            </div>
            <h3 className="text-lg md:text-xl font-semibold">Pembayaran ke Pemasok</h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
            <Select
              label="Siklus Pembayaran Pemasok"
              description="Frekuensi pembayaran ke peternak"
              options={paymentCycleOptions}
              value={formData?.supplierPaymentCycle || ''}
              onChange={(value) => handleInputChange('supplierPaymentCycle', null, value)}
              error={errors?.supplierPaymentCycle}
              required
            />

            <Input
              label="Rata-rata Pembayaran per Siklus"
              type="number"
              placeholder="0"
              description="Dalam Rupiah"
              value={formData?.avgSupplierPayment || ''}
              onChange={(e) => handleInputChange('avgSupplierPayment', null, e?.target?.value)}
              error={errors?.avgSupplierPayment}
              required
            />

            <Input
              label="Jumlah Pemasok Aktif"
              type="number"
              placeholder="0"
              value={formData?.activeSupplierCount || ''}
              onChange={(e) => handleInputChange('activeSupplierCount', null, e?.target?.value)}
              error={errors?.activeSupplierCount}
            />

            <Input
              label="Keterlambatan Pembayaran (Hari)"
              type="number"
              placeholder="0"
              description="Rata-rata keterlambatan jika ada"
              value={formData?.paymentDelayDays || ''}
              onChange={(e) => handleInputChange('paymentDelayDays', null, e?.target?.value)}
              error={errors?.paymentDelayDays}
            />
          </div>
        </div>

        <div className="p-4 md:p-6 bg-muted rounded-lg">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-lg bg-card flex items-center justify-center">
              <Icon name="Building2" size={20} color="var(--color-success)" />
            </div>
            <h3 className="text-lg md:text-xl font-semibold">Pembayaran dari Pelanggan</h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
            <Select
              label="Syarat Pembayaran Pelanggan"
              description="Jangka waktu pembayaran dari pembeli"
              options={customerPaymentOptions}
              value={formData?.customerPaymentTerms || ''}
              onChange={(value) => handleInputChange('customerPaymentTerms', null, value)}
              error={errors?.customerPaymentTerms}
              required
            />

            <Input
              label="Rata-rata Piutang Tertunda"
              type="number"
              placeholder="0"
              description="Dalam Rupiah"
              value={formData?.avgOutstandingReceivables || ''}
              onChange={(e) => handleInputChange('avgOutstandingReceivables', null, e?.target?.value)}
              error={errors?.avgOutstandingReceivables}
            />

            <Input
              label="Persentase Pembayaran Tepat Waktu"
              type="number"
              placeholder="0"
              description="0-100%"
              value={formData?.onTimePaymentPercentage || ''}
              onChange={(e) => handleInputChange('onTimePaymentPercentage', null, e?.target?.value)}
              error={errors?.onTimePaymentPercentage}
            />

            <Input
              label="Piutang Macet (Jika Ada)"
              type="number"
              placeholder="0"
              description="Dalam Rupiah"
              value={formData?.badDebt || ''}
              onChange={(e) => handleInputChange('badDebt', null, e?.target?.value)}
              error={errors?.badDebt}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentTermsSection;